module.exports = __webpack_public_path__ + "media/images/workplace/SVG/defaultAvatar-64976c905a0409557e8d73cd362970e4.svg";